module.exports = __webpack_public_path__ + "static/img/cont1401.deaabc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont1401.jpg
// module id = mIfN
// module chunks = 0